// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ServerModuleStatus,
} from "./types";


export default __t.row({
  id: __t.u32().primaryKey(),
  serviceId: __t.u32().name("service_id"),
  dbName: __t.string().name("db_name"),
  displayName: __t.option(__t.string()).name("display_name"),
  get status() {
    return ServerModuleStatus;
  },
  bootstrappedAt: __t.option(__t.timestamp()).name("bootstrapped_at"),
  lastError: __t.option(__t.string()).name("last_error"),
  createdAt: __t.timestamp().name("created_at"),
  receiveMembership: __t.bool().name("receive_membership"),
});
